
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { acRundeActive } from '../actions/acRundeActive';
import { acRundaSelectata } from '../actions/acRundaSelectata';
import ConBile from '../containers/ConBile';
import { acConSizeChange } from '../actions/acConSizeChange';
// import _ from 'underscore';
// import fn from '../../Functii';

class MidListDDRunde extends React.Component {

    componentWillMount() {
        if (this.props.index === 0) {
            var runq = this.props.rundaVal.round_unique;
            var result = this.props.rundeActive.filter(function (obj) {
                return obj === runq;
            });
            if (result.length === 0) {
                this.props.acRundeActive({ round: this.props.rundaVal.round_unique, type: 'multy' });
                this.props.acRundaSelectata({ ...this.props.rundaVal, gameType: this.props.activeLot.game_type })
            }
        }
    }
    shouldComponentUpdate(nextProps, nextState) {
        var runq = this.props.rundaVal.round_unique;
        var result = this.props.rundeActive.filter(function (obj) {
            return obj === runq;
        });

        var runq2 = nextProps.rundaVal.round_unique;
        var result2 = nextProps.rundeActive.filter(function (obj) {
            return obj === runq2;
        });
        if ((result.length > 0) || (result2.length > 0)) {
            return true
        } else {
            return false;
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // console.log('()()()', this.refMidList.parentElement.parentElement.offsetHeight)
        if (this.props.conSizeChange.colMidH !== this.refMidList.parentElement.parentElement.offsetHeight) {
            this.props.acConSizeChange({
                colMidH: this.refMidList.parentElement.parentElement.offsetHeight
            })
        }
    }
    activeConBile() {
        this.props.acRundeActive({ round: this.props.rundaVal.round_unique, type: 'multy' });
        this.props.acRundaSelectata({ ...this.props.rundaVal, gameType: this.props.activeLot.game_type });
    }
    activeClass() {
        var runq = this.props.rundaVal.round_unique;
        var result = this.props.rundeActive.filter(function (obj) {
            return obj === runq;
        });
        if (result.length > 0) {
            return 'active'
        } else {
            return ''
        }
    }
    timeStartTrim(val) {
        var data = val.split(' ')[0];
        var ora = val.split(' ')[1];
        var dataArr = data.split('-')
        var oraArr = ora.split(':')
        var data2 = "" + dataArr[2] + "." + dataArr[1] + "";
        var ora2 = "" + oraArr[0] + ":" + oraArr[1] + "";
        // var display = "" + data2 + " " + ora2 + "";
        return (
            <span>
                <span>{data2}</span>
                <span>{ora2}</span>
            </span>
        )
    }

    runda() {
        return (
            <tr onClick={this.activeConBile.bind(this)} className={this.activeClass()}>
                <td className="time_round">{this.timeStartTrim(this.props.rundaVal.timeStart)}
                    <span>{this.props.activeLot.name_lot + ' | ' + this.props.activeLot.game_type}</span>
                </td>
                {/* {this._odds()} */}
            </tr>
        )
    }
    _odds() {
        var odds = []
        for (var i = 0; i < this.props.activeLot.odds.length; i++) {
            if (this.props.activeLot.odds[i].slice(-3) === '000') {
                odds.push(<td key={i}>{this.props.activeLot.odds[i].slice(0, -3) + 'k'}</td>)
            } else {
                odds.push(<td key={i}>{this.props.activeLot.odds[i]}</td>)
            }
        }
        return odds;
    }

    render() {
        // console.log('ExtrageriMidItem', this.refMidList);
        return (
            <tbody ref={(f) => this.refMidList = f}>
                {this.runda()}
                <tr className={'con-bile-tr '}>
                    <td colSpan="10">
                        <ConBile
                            rundaVal={this.props.rundaVal}
                            type='multy'
                        />
                    </td>
                </tr>
            </tbody>
        )
    }
}


function mapStateToProps(state) {
    return {
        activeLot: state.activeLot,
        bilete: state.bilete,
        rundeActive: state.rundeActive,
        clientProp: state.clientProp,
        conSizeChange: state.conSizeChange
    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acRundeActive: acRundeActive,
        acRundaSelectata: acRundaSelectata,
        acConSizeChange: acConSizeChange
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(MidListDDRunde);